export default __webpack_public_path__ + "static/media/github.3c903c66.svg";